export default "__VITE_ASSET__905fefbd__"